var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.remaningSecond)?_c('div',[_c('div',{staticClass:"otp-timer-wrap"},[_c('div',[_c('span',{},[_c('i',{staticClass:"fa fa-clock me-1 clock-icon"}),_vm._v(" OTP will expire in "),_c('span',{staticClass:"resend-timer"},[_vm._v(" "+_vm._s(_vm.formattedTime()))]),_vm._v(". ")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }